<template>
    <v-dialog v-model="dialog" persistent max-width="600px">

        <template v-slot:activator="{ on: dialog }">
            <v-tooltip
                    top
                    :open-delay="tooltipDelay"
            >
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn
                        v-if="blobEntry.id === undefined"
                        v-on="{ ...tooltip, ...dialog}"
                        icon
                        fab
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                        v-else
                        v-on="{ ...tooltip, ...dialog}"
                        x-small
                        :color="btnColor"
                        dark
                        icon
                    >
                        <v-icon size="medium">mdi-pencil</v-icon>
                    </v-btn>
                </template>
                <span v-if="blobEntry.id === undefined">{{ $t('controls.tooltip.add_entry') }}</span>
                <span v-else>{{ $t('controls.tooltip.edit_entry') }}</span>
            </v-tooltip>
        </template>

        <EntryForm
            v-if="dialog"
            :blob-entry="blobEntry"
            :cancel="true"
            v-on:entryIsProcessed="done"
            v-on:entryIsCanceled="close"
        ></EntryForm>
    </v-dialog>
</template>

<script>
  import EntryForm from './EntryForm'
  import { settings } from '../../settings/settings.js'

  export default {
    name: 'EntryFormDialog',
    components: { EntryForm },
    props: {
      blobEntry: {
        type: Object,
        default () {
          return {}
        }
      },
      btnColor: {
        type: String,
        default: null
      }
    },
    data: () => ({
      ...settings,
      dialog: false
    }),
    methods: {
      done () {
        this.dialog = false
      },
      close () {
        this.dialog = false
      }
    }
  }
</script>
